module.exports = __webpack_public_path__ + "img/gate_exist_tat.5776f331.svg";